<template>
  <div>
    <md-dialog :md-active.sync="showDialog" v-on:md-closed="closed">
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-dialog-title>Редактирование пользователя</md-dialog-title>
        <form novalidate class="md-layout">
          <md-card class="md-layout-item">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <label for="company">Укажите компанию, для переноса</label>
                    <CompanySearch name="company" v-on:setCompany="setCompany"></CompanySearch>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="user_name">Логин</label>
                    <md-input name="user_name" id="user_name" autocomplete="given-name" v-model="form.name" required maxlength="255"/>
                    <div class="md-error" v-if="!this.$v.form.name.required">{{ t('user.create.required') }}</div>

                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="email">E-mail</label>
                    <md-input name="email" id="email" autocomplete="given-name" v-model="form.email" maxlength="255"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="this.country_code === 'ru'">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('name')">
                    <label for="email">ИНН</label>
                    <md-input name="inn" id="inn" autocomplete="given-name" v-model="form.inn" required minlength="12" maxlength="12"/>
                    <div class="md-error" v-if="!this.$v.form.inn.required">{{ t('user.create.required') }}</div>
                    <div class="md-error" v-if="!this.$v.form.inn.numeric">{{ t('user.create.dirty') }}</div>
                    <div class="md-error" v-if="!this.$v.form.inn.minLength">{{ t('user.create.dirty') }}</div>
                    <div class="md-error" v-if="!this.$v.form.inn.maxLength">{{ t('user.create.dirty') }}</div>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
              <div class="md-layout-item ">
                <md-field>
                  <label for="user_type">Тип</label>
                  <md-select v-model="form.role_id" name="role_id" id="role_id" @md-selected="changeUsersFilter" md-dense required>
                    <md-option v-for="(item, index) in roles"
                               :value="index"
                               :key="index">{{ item }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('gender')">
                    <label for="last_name">Фамилия</label>
                    <md-input name="last_name" id="last_name" autocomplete="family-name" v-model="form.last_name" maxlength="16"/>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('gender')">
                    <label for="first_name">Имя</label>
                    <md-input name="first_name" id="first_name" autocomplete="family-name" v-model="form.first_name" maxlength="16"/>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('gender')">
                    <label for="middle_name">Отчество</label>
                    <md-input name="middle_name" id="middle_name" autocomplete="family-name" v-model="form.middle_name" maxlength="16"/>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label for="status">Статус</label>
                <md-select v-model="form.status_id" name="status" id="status">
                  <md-option value="1" :key="'status_1'">Активный</md-option>
                  <md-option value="0" :key="'status_2'">Неактивный</md-option>
                </md-select>
              </md-field>

            </md-card-content>
          </md-card>
        </form>
        <md-dialog-actions>
          <md-button class="md-primary ct-red pointer" @click="resetPassword">Сбросить пароль</md-button>
          <md-button class="md-primary ct-yellow pointer" @click="showDialog = false">Закрыть</md-button>
          <md-button class="md-primary ct-green pointer" @click="submitForm">Сохранить</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import Responses from '@/api/responses'
import CompanySearch from '../common/forms/CompanySearch.vue'
import { maxLength, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators'

export default {
  components: { CompanySearch },
  name: 'EditUsersDialog',
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
      role_id: null,
      status_id: null,
      inn: null,
      last_name: null,
      first_name: null,
      middle_name: null,
      email: null
    },
    shopId: null,
    country_code: 'kz',
    cashType: null,
    items: [],
    cashSaved: false,
    sending: false,
    showDialog: false,
    loadDialog: false,
    isOperdayActive: false,
    userData: {},
    roles: []
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4)
      },
      inn: {
        required: requiredIf(function () {
          return this.isRuRegion
        }),
        numeric,
        minLength: minLength(12),
        maxLength: maxLength(12)
      }
    }
  },
  computed: {
    isRuRegion () {
      return this.country_code === 'ru'
    }
  },
  methods: {
    setCompany (shopId) {
      this.form.company_id = shopId
    },
    resetPassword () {
      HttpClient.httpPatch(['users.resetPassword', this.form.shopId, this.$store.state.editId])
        .then(resp => {
          Responses.successRspMessage('Выполнено успешно', 'Сброс пароля')
          this.stopLoading()
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    submitCheck () {
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'OK'
      }
    },
    submitForm () {
      this.sending = true
      this.$v.$touch()
      this.submitCheck()

      for (let field in this.form) {
        if (this.form.hasOwnProperty(field)) {
          this.getValidationClass(field)
          this.userData[field] = this.form[field]
        }
      }

      if (this.submitStatus !== 'OK') {
        return
      }

      this.startLoading()

      for (let i in this.form) {
        this.userData[i] = this.form[i]
      }
      this.successSave = true
      HttpClient.httpPatch(['users.edit', this.form.shopId, this.$store.state.editId], this.userData)
        .then(() => {
          Responses.successRspMessage('Выполнено успешно', 'Сохранение')
          this.stopLoading()
          this.showDialog = false
          this.$emit('closeEditDialog')
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    clearForm () {
      this.$v.$reset()
      for (let i in this.form) {
        this.form[i] = null
      }
    },
    setUsersInfo (response) {
      this.form.name = response.name
      this.form.role_id = response.role_id
      this.form.last_name = response.last_name
      this.form.first_name = response.first_name
      this.form.middle_name = response.middle_name
      this.form.email = response.email
      this.form.inn = response.inn
      this.form.status_id = response.status.id

      this.userData = response
    },
    getEditData () {
      this.startLoading()
      return HttpClient.httpGet(['users.getById', this.form.shopId, this.$store.state.editId])
    },
    changeUsersFilter () {
      this.$emit('changeUsersFilter')
    },
    changeFilter () {
      this.$store.commit('setFilter', {name: 'name', value: this.name_search})
      this.$store.commit('setFilter', {name: 'q', value: this.name_search})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    closed () {
      if (this.successSave === true) {
        this.$emit('closeDialogSuccess')
      } else {
        this.$emit('closeDialog')
      }
      this.successSave = false
    }
  },
  async created () {
    this.startLoading()
    if (!this.$store.state.editId) {
      this.showDialog = false
      return false
    }
    this.form.shopId = this.$store.state.shopId
    this.roles = this.$store.state.roles
    this.country_code = this.$store.state.filtersUsers.country_code
    this.showDialog = true
    const $this = this
    let response = await Promise.all([$this.getEditData()])
    if (response) {
      this.setUsersInfo(response[0])
    }
    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
  .md-dialog {
    min-width: 25%;
    min-height: 60%;
    overflow: auto;
  }

  .md-tooltip{
    max-width: 500px;

  }
  .md-card {
    margin: 5px 0 0 0;
    overflow: unset;
  }
  .loading-overlay {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 450px;
    background: none;
    position: absolute;
    z-index: 9;
  }

  .md-button.ct-green {
    background-color: green !important;
  }

  .md-button.ct-yellow {
    background-color: #e29641 !important;
  }
  .md-button.ct-red {
    background-color: #e91e63 !important;
  }

  .pointer {
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/users/UsersEdit.vue